import React from 'react';
import { Button } from './ui/button';
import { Download, FileText, BarChart3 } from 'lucide-react';

interface DownloadResultsProps {
  jobId: string;
  disabled?: boolean;
}

export const DownloadResults: React.FC<DownloadResultsProps> = ({ jobId, disabled }) => {
  return (
    <div className="space-y-4">
      <div className="text-white">
        <h3 className="font-medium mb-2">Download Results</h3>
        <p className="text-slate-400 text-sm mb-4">
          Your ranked list is ready! Download your results in various formats.
        </p>
      </div>
      
      <div className="space-y-3">
        <Button 
          variant="outline" 
          className="w-full justify-start"
          disabled={disabled}
        >
          <FileText className="w-4 h-4 mr-2" />
          Download CSV with Rankings
        </Button>
        
        <Button 
          variant="outline" 
          className="w-full justify-start"
          disabled={disabled}
        >
          <BarChart3 className="w-4 h-4 mr-2" />
          Download Analysis Report
        </Button>
        
        <Button 
          variant="outline" 
          className="w-full justify-start"
          disabled={disabled}
        >
          <Download className="w-4 h-4 mr-2" />
          Download Full Dataset
        </Button>
      </div>
      
      {disabled && (
        <p className="text-slate-500 text-sm">
          Complete the job to enable downloads
        </p>
      )}
    </div>
  );
}; 